<template>
    <div id="app">
        <div class="content">
            <div class="swot-header row">
                <div class="swot-header-letter shs col-3 align-middle">
                    <h2>S</h2>
                    <h5>Strengths</h5>
                </div>
                <div class="data data-s col-9">
                    <div class="">
                        <input type="text" :class="{novalue: !s1}" v-model="s1" class="form-control" placeholder="Things your company does well">
                    </div>
                    <div class="">
                        <input type="text" :class="{novalue: !s2}" v-model="s2"  class="form-control" placeholder="Qualities that separate you from your competitors">
                    </div>
                    <div class="">
                        <input type="text" :class="{novalue: !s3}" v-model="s3"  placeholder="Internal resources such as skilled, knowledgeable stuff" class="form-control">
                    </div>
                    <div class="">
                        <input type="text" :class="{novalue: !s4}" v-model="s4"  placeholder="Tangible assets such as intellectual property, capital, proprietary technologies etc." class="form-control">
                    </div>
                </div>

                <div class="swot-header-letter shw col-3 align-middle">
                    <h2>W</h2>
                    <h5>Weaknesses</h5>
                </div>
                <div class="data data-w col-9">
                    <div class="">
                        <input type="text" :class="{novalue: !w1}" v-model="w1"  class="form-control" placeholder="Things your company lacks">
                    </div>
                    <div class="">
                        <input type="text" :class="{novalue: !w2}" v-model="w2" class="form-control" placeholder="Things your competitors do better then you">
                    </div>
                    <div class="">
                        <input type="text" :class="{novalue: !w3}" v-model="w3" placeholder="Resource limitations" class="form-control">
                    </div>
                    <div class="">
                        <input type="text" :class="{novalue: !w4}" v-model="w4" placeholder="Unclear unique selling proposition" class="form-control">
                    </div>
                </div>

                <div class="swot-header-letter sho col-3 align-middle">
                    <h2>O</h2>
                    <h5>Opportunities</h5>
                </div>
                <div class="data data-o col-9">
                    <div class="">
                        <input type="text" :class="{novalue: !o1}" v-model="o1" class="form-control" placeholder="Underserved market for specific products">
                    </div>
                    <div class="">
                        <input type="text" :class="{novalue: !o2}" v-model="o2" class="form-control" placeholder="Few competitors in your area">
                    </div>
                    <div class="">
                        <input type="text" :class="{novalue: !o3}" v-model="o3" placeholder="Emerging need for your products or services" class="form-control">
                    </div>
                    <div class="">
                        <input type="text" :class="{novalue: !o4}" v-model="o4" placeholder="Press/media coverage of your company" class="form-control">
                    </div>
                </div>
                <div class="swot-header-letter sht col-3 align-middle">
                    <h2>T</h2>
                    <h5>Threats</h5>
                </div>
                <div class="data data-t col-9">
                    <div class="">
                        <input type="text" :class="{novalue: !t1}" v-model="t1" class="form-control" placeholder="Emerging competitors">
                    </div>
                    <div class="">
                        <input type="text" :class="{novalue: !t2}" v-model="t2" class="form-control" placeholder="Changing regulatory environment">
                    </div>
                    <div class="">
                        <input type="text" :class="{novalue: !t3}" v-model="t3" placeholder="Negative press/media coverage" class="form-control">
                    </div>
                    <div class="">
                        <input type="text" :class="{novalue: !t4}" v-model="t4" placeholder="Changing customer attitudes toward your company" class="form-control">
                    </div>
                </div>
            </div>
            <div style="clear: both"></div>
            <vue-html2pdf
                    :show-layout="false"
                    :float-layout="true"
                    :enable-download="true"
                    :preview-modal="false"
                    :paginate-elements-by-height="2900"
                    filename="swot_analysis"
                    :pdf-quality="2"
                    :manual-pagination="false"
                    pdf-format="a4"
                    pdf-orientation="landscape"
                    pdf-content-width="800px"
                    @hasDownloaded="sendEmail"
                    ref="html2Pdf"
            >
                <section slot="pdf-content">
                    <div id="pdf" style="display: none">
                        <div>
                            <div class="apart shs">
                                <h2>S</h2>
                                <h5>Strengths</h5>
                            </div>
                            <div class="pdf-data pdf-s">
                                <ul>
                                    <li class="">
                                        {{s1}}
                                    </li>
                                    <li class="">
                                        {{s2}}
                                    </li>
                                    <li class="">
                                        {{s3}}
                                    </li>
                                    <li class="">
                                        {{s4}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div>
                            <div class="apart shw">
                                <h2>W</h2>
                                <h5>Weaknesses</h5>
                            </div>
                            <div class="pdf-data pdf-w">
                                <ul>
                                    <li class="">
                                        {{w1}}
                                    </li>
                                    <li class="">
                                        {{w2}}
                                    </li>
                                    <li class="">
                                        {{w3}}
                                    </li>
                                    <li class="">
                                        {{w4}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div>
                            <div class="apart sho">
                                <h2>O</h2>
                                <h5>Opportunities</h5>
                            </div>
                            <div class="pdf-data pdf-o">
                                <ul>
                                    <li class="">
                                        {{o1}}
                                    </li>
                                    <li class="">
                                        {{o2}}
                                    </li>
                                    <li class="">
                                        {{o3}}
                                    </li>
                                    <li class="">
                                        {{o4}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div>
                            <div class="apart sht">
                                <h2>T</h2>
                                <h5>Threats</h5>
                            </div>
                            <div class="pdf-data pdf-t">
                                <ul>
                                    <li class="">
                                        {{t1}}
                                    </li>
                                    <li class="">
                                        {{t2}}
                                    </li>
                                    <li class="">
                                        {{t3}}
                                    </li>
                                    <li class="">
                                        {{t4}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
            </vue-html2pdf>
        </div>

        <footer id="menu-header" class="footer">
            <button class="btn btn-primary btn-sm" type="button" style="width:90px" @click="window.print()">Print</button>
            <button class="btn btn-success  btn-sm" type="button" style="margin-left:20px;width:90px" @click="generateReport()">Download</button>
            <button class="btn btn-danger  btn-sm" type="button" style="margin-left:20px;width:90px" @click="window.location.href= 'https://getoutofthetruck.life'">X</button>
        </footer>
    </div>
</template>

<script>
  import VueHtml2pdf from 'vue-html2pdf'
  import axios from 'axios'

  export default {
    name: 'App',
    components: {
      VueHtml2pdf,
    },
    data: () => ({
      window: window,
      steps: 6,
      step: undefined,
      s1: null,
      s2: null,
      s3: null,
      s4: null,
      w1: null,
      w2: null,
      w3: null,
      w4: null,
      o1: null,
      o2: null,
      o3: null,
      o4: null,
      t1: null,
      t2: null,
      t3: null,
      t4: null,
    }),
    methods: {
      generateReport () {
        document.getElementById('pdf').style.display = "block";
        document.getElementById('menu-header').style.display = "none";
        this.$refs.html2Pdf.generatePdf();
        setTimeout(() => {
          document.getElementById('pdf').style.display = "none";
          document.getElementById('menu-header').style.display = "block";
        }, 3000)

      },
      sendEmail(e){
        let reader = new FileReader();
        reader.readAsDataURL(e);
        reader.onloadend = function() {
          let base64data = reader.result;
          axios.post('https://911.gazingle.com/get_out_of_the_truck/swot', {
            file: base64data,
          })
            .then(() => {
            })
            .catch(() => {

            });
        }
      },
      blobToFile(theBlob, fileName){
        theBlob.lastModifiedDate = new Date();
        theBlob.name = fileName;
        return theBlob;
      },
    },
  }
</script>

<style scoped>
    html, body {
        height: 100%;
    }
    #app{
        display: flex;
        flex-direction: column;
    }
    .content {
        flex: 1 0 auto;
    }
    .footer {
        flex-shrink: 0;
        text-align: center;
        padding-bottom: 10px
    }
    .p-t-20{
        padding-top:0px;
        padding-bottom:20px;
    }
    .swot-header {
        height: calc(100vh - 40px);
        margin:0;
    }
    .swot-header > div{
        height: calc(25vh - 10px);
        display: inline-block;
    }
    .swot-header-letter h2{
        font-size:450%;
        font-weight: bold;
        color:white;
        display:block;
        text-align:center;
        margin-top:2.5vh
    }
    .swot-header h5{
        font-size:125%;
        text-transform: uppercase;
        color:white;
        text-align:center
    }
    .shs{
        background: #3379b8;
        padding-left:30px;
    }
    .shw{
        background: #f09055;
        padding-left:30px;
    }
    .sho{
        background: #5bbb61;
        padding-left:30px;
    }
    .sht{
        background: #6668aa;
        padding-left:30px;
    }
    .swot-header-letter{
        height: calc(25vh - 13px);
        text-align: center;
        /*display: flex;*/
        /*justify-content: center;*/
        /*align-items: center;*/
    }
    .data{
        padding:10px 30px;
    }
    .data label{
        display:none
    }
    .data input{
        background: none;
        border:0;
        height: 30px;
        padding:3px;
        font-size: 75%;
        margin-bottom:10px;
    }
    input:after, input:before {
        content:"\A";
        width:10px;
        height:10px;
        border-radius:50%;
        background: #b83b3b;
        display:inline-block;
    }
    .data-s{
        color: #3379b8;
        background: rgba(51, 121, 184, 0.2);
    }
    .data-s input{
        color: #3379b8;
    }
    .data-s input::placeholder {
        color: #3379b8;
        font-style: italic;
    }

    .data-w{
        color: rgba(240, 144, 85, 1);
        background: rgba(240, 144, 85, 0.2);
    }
    .data-w input, .data-w{
        color: rgba(240, 144, 85, 1);
    }
    .data-w input::placeholder {
        color: rgba(240, 144, 85, 1);
        font-style: italic;
    }

    .data-o{
        color: rgba(91, 187, 97, 1);
        background: rgba(91, 187, 97, 0.2);
    }
    .data-o input{
        color: rgba(91, 187, 97, 1);
    }
    .data-o input::placeholder {
        color: rgba(91, 187, 97, 1);
        font-style: italic;
    }
    #menu-header{
        padding-top:4px;
    }

    .data-t{
        color: rgba(102, 104, 170, 1);
        background: rgba(102, 104, 170, 0.2);
    }
    .data-t input{
        color: rgba(102, 104, 170, 1);
    }
    .data-t input::placeholder {
        color: rgba(102, 104, 170, 1);
        font-style: italic;
    }
    .novalue{
        border-bottom:1px dashed silver!important;
    }
    #pdf > div{
        width:100%;
        height:198px;
    }
    #pdf h2{
        margin-top:20px;
        font-size: 80px;
        color:white;
        text-align: center;
        padding:0;
        margin-left: -10px
    }
    #pdf h5{
        font-size: 20px;
        color:white;
        text-align: center;
        text-transform: uppercase;
        padding:0;
        margin-left: -10px
    }
    #pdf .apart{
        float: left;
        width:200px;
        height:198px;
        margin-left:-20px;
    }
    #pdf .pdf-data {
        width:calc(1125px);
        height:198px;
        padding-left:100px;
    }
    #pdf .pdf-s{
        color: #3379b8;
        background: rgba(51, 121, 184, 0.2);
    }
    #pdf .pdf-w{
        color: rgba(240, 144, 85, 1);
        background: rgba(240, 144, 85, 0.2);
    }
    #pdf .pdf-o{
        color: rgba(91, 187, 97, 1);
        background: rgba(91, 187, 97, 0.2);
    }
    #pdf .pdf-t{
        color: rgba(102, 104, 170, 1);
        background: rgba(102, 104, 170, 0.2);
    }
    #pdf ul{
        list-style: circle;
        padding-left:30px;
        margin-left:50px;
        vertical-align: middle;
        padding-top:15px;
    }
    #pdf ul li{
        list-style: circle;
        padding-left:30px;
        margin-left:50px;
        height: 35px;
    }
    @media only screen and (max-width: 600px) {
        h2{

        }
        h5, .swot-header h5{
            font-size:70%;

        }
        .swot-header-letter{
            padding:0
        }
        .data input{
            /*font-size:100%;*/
        }
        .col-9{
            padding:10px
        }
    }
</style>
